import _defineProperty from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEscapeKeydown as e } from "@radix-ui/react-use-escape-keydown";
import { useCallbackRef as t } from "@radix-ui/react-use-callback-ref";
import { useBodyPointerEvents as n } from "@radix-ui/react-use-body-pointer-events";
import { createContext as r } from "@radix-ui/react-context";
import { Primitive as o } from "@radix-ui/react-primitive";
import { composeEventHandlers as u } from "@radix-ui/primitive";
import * as i from "react";
import s from "@babel/runtime/helpers/esm/extends";

var _C = C(),
    _C2 = _slicedToArray(_C, 2),
    a = _C2[0],
    c = _C2[1],
    _b = b(),
    _b2 = _slicedToArray(_b, 2),
    l = _b2[0],
    d = _b2[1],
    _C3 = C("TotalLayerCountWithDisabledOutsidePointerEventsProvider"),
    _C4 = _slicedToArray(_C3, 2),
    m = _C4[0],
    f = _C4[1],
    _b3 = b("RunningLayerCountWithDisabledOutsidePointerEventsProvider"),
    _b4 = _slicedToArray(_b3, 2),
    p = _b4[0],
    v = _b4[1];

export var DismissableLayer = /*#__PURE__*/i.forwardRef(function (e, t) {
  var n = 0 === d(),
      r = /*#__PURE__*/i.createElement(E, s({}, e, {
    ref: t
  }));
  return n ? /*#__PURE__*/i.createElement(a, null, /*#__PURE__*/i.createElement(m, null, r)) : r;
});
/*#__PURE__*/

var E = /*#__PURE__*/i.forwardRef(function (r, a) {
  var _r$disableOutsidePoin = r.disableOutsidePointerEvents,
      m = _r$disableOutsidePoin === void 0 ? !1 : _r$disableOutsidePoin,
      E = r.onEscapeKeyDown,
      C = r.onPointerDownOutside,
      b = r.onFocusOutside,
      w = r.onInteractOutside,
      L = r.onDismiss,
      y = _objectWithoutProperties(r, _excluded),
      D = c(),
      P = d() + 1,
      T = P === D,
      g = f(m),
      x = v() + (m ? 1 : 0),
      O = x < g;

  n({
    disabled: m
  }), e(function (e) {
    T && (null == E || E(e), e.defaultPrevented || null == L || L());
  });

  var _ref = function (e) {
    var n = t(e),
        r = i.useRef(!1);
    return i.useEffect(function () {
      var e = function e(_e) {
        var t = _e.target;

        if (t && !r.current) {
          var _r = new CustomEvent("dismissableLayer.pointerDownOutside", {
            bubbles: !1,
            cancelable: !0,
            detail: {
              originalEvent: _e
            }
          });

          t.addEventListener("dismissableLayer.pointerDownOutside", n, {
            once: !0
          }), t.dispatchEvent(_r);
        }

        r.current = !1;
      },
          t = window.setTimeout(function () {
        document.addEventListener("pointerdown", e);
      }, 0);

      return function () {
        window.clearTimeout(t), document.removeEventListener("pointerdown", e);
      };
    }, [n]), {
      onPointerDownCapture: function onPointerDownCapture() {
        return r.current = !0;
      }
    };
  }(function (e) {
    O || (null == C || C(e), null == w || w(e), e.defaultPrevented || null == L || L());
  }),
      R = _ref.onPointerDownCapture,
      _ref2 = function (e) {
    var n = t(e),
        r = i.useRef(!1);
    return i.useEffect(function () {
      var e = function e(_e2) {
        var t = _e2.target;

        if (t && !r.current) {
          var _r2 = new CustomEvent("dismissableLayer.focusOutside", {
            bubbles: !1,
            cancelable: !0,
            detail: {
              originalEvent: _e2
            }
          });

          t.addEventListener("dismissableLayer.focusOutside", n, {
            once: !0
          }), t.dispatchEvent(_r2);
        }
      };

      return document.addEventListener("focusin", e), function () {
        return document.removeEventListener("focusin", e);
      };
    }, [n]), {
      onFocusCapture: function onFocusCapture() {
        return r.current = !0;
      },
      onBlurCapture: function onBlurCapture() {
        return r.current = !1;
      }
    };
  }(function (e) {
    null == b || b(e), null == w || w(e), e.defaultPrevented || null == L || L();
  }),
      h = _ref2.onBlurCapture,
      F = _ref2.onFocusCapture,
      k = g > 0 && !O;
  /*#__PURE__*/


  return i.createElement(l, {
    runningCount: P
  }, /*#__PURE__*/i.createElement(p, {
    runningCount: x
  }, /*#__PURE__*/i.createElement(o.div, s({}, y, {
    ref: a,
    style: _objectSpread({
      pointerEvents: k ? "auto" : void 0
    }, y.style),
    onPointerDownCapture: u(r.onPointerDownCapture, R),
    onBlurCapture: u(r.onBlurCapture, h),
    onFocusCapture: u(r.onFocusCapture, F)
  }))));
});

function C(e) {
  var _r3 = r("TotalLayerCount", {
    total: 0,
    onTotalIncrease: function onTotalIncrease() {},
    onTotalDecrease: function onTotalDecrease() {}
  }),
      _r4 = _slicedToArray(_r3, 2),
      t = _r4[0],
      n = _r4[1],
      o = function o(_ref3) {
    var e = _ref3.children;

    var _i$useState = i.useState(0),
        _i$useState2 = _slicedToArray(_i$useState, 2),
        n = _i$useState2[0],
        r = _i$useState2[1];
    /*#__PURE__*/


    /*#__PURE__*/
    return i.createElement(t, {
      total: n,
      onTotalIncrease: i.useCallback(function () {
        return r(function (e) {
          return e + 1;
        });
      }, []),
      onTotalDecrease: i.useCallback(function () {
        return r(function (e) {
          return e - 1;
        });
      }, [])
    }, e);
  };

  return [o, function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;

    var _n = n("TotalLayerCountConsumer"),
        t = _n.total,
        r = _n.onTotalIncrease,
        o = _n.onTotalDecrease;

    return i.useLayoutEffect(function () {
      if (e) return r(), function () {
        return o();
      };
    }, [e, r, o]), t;
  }];
}

function b(e) {
  var _r5 = r("RunningLayerCount", {
    count: 0
  }),
      _r6 = _slicedToArray(_r5, 2),
      t = _r6[0],
      n = _r6[1],
      o = function o(e) {
    var n = e.children,
        r = e.runningCount;
    /*#__PURE__*/

    /*#__PURE__*/
    return i.createElement(t, {
      count: r
    }, n);
  };

  return [o, function () {
    return n("RunningLayerCountConsumer").count || 0;
  }];
}

export var Root = DismissableLayer;